export default "__VITE_ASSET__DlIserwY__"